module.exports = __webpack_public_path__ + "media/img/Landing_Page/twitter-icon-d4cb6c1251d7a4d8ae255d9e73125a85.png";